<!-- components/LegitimuzElements.vue -->
<script setup>
import { computed } from 'vue';
import { useLegitimuzVerification } from '~/composables/base/useLegitimuzVerification';

const props = defineProps({
  cpf: {
    type: String,
    default: null
  }
});


const {
  legitimuzCpf: cpfFromComposable,
} = useLegitimuzVerification();


const legitimuzCpf = computed(() => props.cpf || cpfFromComposable);
</script>

<template>
  <div class="legitimuz-container">
    <input id="legitimuz-hydrate-cpf" type="tel" v-model="legitimuzCpf" class="hidden" />
    <button id="legitimuz-action-verify" class="hidden"></button>
    <button id="legitimuz-action-faceindex" class="hidden"></button>
    <div id="legitimuz-root" class="z-100"></div>
  </div>
</template>